/**
 * Keeps Mailchimp BIRTHDAY[month] / BIRTHDAY[day] hidden fields in sync with a native
 * <input type="date" data-mc-birthday> (so iframe / programmatic submits still work).
 */
(function () {
  function sync(dateInput) {
    var form = dateInput.closest('form');
    if (!form) return;
    var monthHidden = form.querySelector('input[name="BIRTHDAY[month]"]');
    var dayHidden = form.querySelector('input[name="BIRTHDAY[day]"]');
    if (!monthHidden || !dayHidden) return;

    var v = dateInput.value;
    if (!v) {
      monthHidden.value = '';
      dayHidden.value = '';
      return;
    }

    var parts = v.split('-');
    if (parts.length !== 3) return;

    var month = parseInt(parts[1], 10);
    var day = parseInt(parts[2], 10);
    if (month < 1 || month > 12 || day < 1 || day > 31) return;

    monthHidden.value = String(month);
    dayHidden.value = String(day);
  }

  function onDateFieldEvent(e) {
    if (!e.target || !e.target.matches || !e.target.matches('input[type="date"][data-mc-birthday]')) {
      return;
    }
    sync(e.target);
  }

  document.addEventListener('change', onDateFieldEvent);
  document.addEventListener('input', onDateFieldEvent);

  document.addEventListener(
    'submit',
    function (e) {
      var t = e.target;
      if (!t || !t.querySelectorAll) return;
      t.querySelectorAll('input[type="date"][data-mc-birthday]').forEach(sync);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('input[type="date"][data-mc-birthday]').forEach(sync);
  });
})();
